export const hashStringToNumber = (text: string) => {
  const arr = text.split('');

  const sbdm = arr.reduce((hashCode, currentVal) => {
    return currentVal.charCodeAt(0) + (hashCode << 6) + (hashCode << 16) - hashCode;
  }, 0);

  return Math.abs(sbdm);
};

const seedShuffle = <T>(array: T[], seed = 1) => {
  const arrayCopy = [...array];

  let currentIndex = arrayCopy.length;
  let temporaryValue: T;
  let randomIndex: number;

  let localSeed = seed;

  const random = () => {
    const x = Math.sin(localSeed++) * 10000;

    return x - Math.floor(x);
  };

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = arrayCopy[currentIndex];
    arrayCopy[currentIndex] = arrayCopy[randomIndex];
    arrayCopy[randomIndex] = temporaryValue;
  }

  return arrayCopy;
};

export default seedShuffle;
